import axios from 'axios';
import { getPropertyUrl } from '../constants';
import { PropertyInfo } from './types';

export const getPropertyInfo = async () => {
  const response = await axios.get<PropertyInfo>(getPropertyUrl);
  return response.data;
};
